import React from 'react';

export default function Avatar({ name, size = 36, color = '#C7D2FE', textColor = '#14532d' }) {
  const initials = name ? name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase() : '?';
  return (
    <div style={{ width: size, height: size, borderRadius: '50%', background: color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: size * 0.35, fontWeight: 700, color: textColor, flexShrink: 0 }}>
      {initials}
    </div>
  );
}
